import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { apiMain } from "services";
import { routes } from "routes";
import { IMigrateResponse } from "services/types";
import VerifiedUserIcon from "components/UI/VerifiedUserIcon";
import "components/buttons/BaseButton/BaseButton.scss";

import "./MigrateImgurPage.scss";

export const MigrateImgurPage = (): JSX.Element => {
  const navigate = useNavigate();

  const [redirect, setRedirect] = useState<string|null>(null);
  const [error, setError] = useState<string|null>(null);
  const [errorCode, setErrorCode] = useState<string|null>(null);

  document.title = "Migrate from Imgur";

  apiMain.getImgurMigrateURL().then((e: IMigrateResponse) => {
    setRedirect(e.url);
  }).catch((e: any) => {
    setError(e.response?.data?.error?.message || "There was an error talking to Imgur, please try again later.");
    setErrorCode(e.response?.data?.error?.code ?? null);
  });

  const handleGetVerified = useCallback(() => {
    navigate(routes.verify());
  }, [navigate]);

  const state = (() => {
    if (errorCode === "VerifiedOnly") {
      return "unverified";
    }

    if (error !== null) {
      return "error";
    }

    if (redirect) {
      return "ready";
    }

    return "default";
  })();

  return (
    <div className="migratePage narrow page">
      <h1>Transfer your content from Imgur</h1>

      <p>With this tool, you can easily migrate all content from your imgur profile to your RedGIFs profile.</p>

      {state === "unverified" && (<>
        <p>You must be a verified creator to transfer your content.</p>

        <button className="BaseButton BaseButton_isSecondary" onClick={handleGetVerified}>
          <VerifiedUserIcon /> &nbsp;Get Verified
        </button>
      </>)}

      {state === "error" && (
        <p>{error}</p>
      )}

      {state === "ready" && redirect && (<>
        <p>After clicking below, you will be redirected to an imgur page where you will be asked
        to allow the RedGIFs migration tool to access your account. Please allow that and
        the migration will begin.</p>

        <a href={redirect} referrerPolicy="no-referrer" className="BaseButton BaseButton_isPrimary"><span>Connect with Imgur</span></a>
      </>)}

      {state === "default" && (
        <p>Checking status...</p>
      )}
    </div>
  );
};
